import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'

import { PaymentMethodCard } from './payment-method-card'
import { openStripeTab } from './stripe-tab'
import { useBillingOverview } from './use-billing-overview'
import { usePaymentMethod } from './use-payment-method'
import { usePlanActions } from './use-plan-actions'

export function PaymentMethodPanel() {
  const query = useBillingOverview()
  const actions = usePlanActions()
  const overview = query.data

  const onCard = overview?.collectionMethod === 'charge_automatically'
  const method = usePaymentMethod(Boolean(overview?.portalAvailable && onCard))

  /* opened synchronously on the click: a window.open after the await is treated
   * as a popup and blocked. */
  function open() {
    actions.portal.mutate({ tab: openStripeTab() })
  }

  return (
    <>
      <p className='text-[13px] text-ink-soft'>
        Your card, billing address, and receipts are managed by Stripe.
      </p>

      {query.isLoading && <Skeleton className='h-32 w-full' />}

      {overview && (
        <div className='flex flex-col gap-4 rounded-xl border border-border p-5'>
          {!onCard ? (
            <>
              <p className='text-[14px] font-medium text-ink'>
                You pay by invoice
              </p>
              <p className='text-[13px] text-ink-soft'>
                We email an invoice each billing period, payable by card or bank
                transfer from the invoice itself. Your open invoices and
                receipts are under Payment history.
              </p>
            </>
          ) : !overview.portalAvailable ? (
            <>
              <p className='text-[14px] font-medium text-ink'>
                Your plan is managed by TandemOne
              </p>
              <p className='text-[13px] text-ink-soft'>
                There is no payment method on file. Message support to change
                how this account is billed.
              </p>
            </>
          ) : (
            <div className='flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-start sm:justify-between'>
              <div className='min-w-0 flex-1'>
                {method.isLoading && (
                  <Skeleton className='h-10 w-full max-w-56' />
                )}
                {method.isError && (
                  <p className='text-[13px] text-ink-soft'>
                    We couldn&rsquo;t reach Stripe for the card on file.
                  </p>
                )}
                {method.data &&
                  (method.data.method ? (
                    <PaymentMethodCard method={method.data.method} />
                  ) : (
                    <p className='text-[13px] text-ink-soft'>
                      No payment method saved yet.
                    </p>
                  ))}
              </div>
              <Button
                className='w-full shrink-0 sm:w-auto'
                disabled={actions.portal.isPending}
                onClick={open}
              >
                Update payment method
              </Button>
            </div>
          )}
        </div>
      )}
    </>
  )
}
